import React from 'react';
import { Gift, FileText, Globe, Star } from 'lucide-react';
import { motion } from 'framer-motion';
const bonuses = [{
  text: 'Lista de 50 Nichos Faceless en Latam',
  icon: Globe
}, {
  text: 'Plantillas de guiones Copy-Paste',
  icon: FileText
}, {
  text: 'Guía para cobrar dólares en México',
  icon: Star
}];
export function BonusSection() {
  return <div className="bg-gradient-to-b from-[#1a2744] to-[#0a1628] rounded-3xl p-8 md:p-12 border border-[#d4a843]/30 relative overflow-hidden" data-id="element-13">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#d4a843] opacity-5 rounded-full blur-3xl transform translate-x-1/3 -translate-y-1/3" data-id="element-14" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#d4a843] opacity-5 rounded-full blur-3xl transform -translate-x-1/3 translate-y-1/3" data-id="element-15" />

      <div className="relative z-10 text-center mb-10" data-id="element-16">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#d4a843] text-[#0a1628] mb-6 shadow-[0_0_20px_rgba(212,168,67,0.4)]" data-id="element-17">
          <Gift className="w-8 h-8" data-id="element-18" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 font-serif" data-id="element-19">
          Bono Opcional
        </h2>
        <p className="text-[#d4a843] text-lg max-w-2xl mx-auto" data-id="element-20">
          Herramientas exclusivas para acelerar tus resultados
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-21">
        {bonuses.map((bonus, index) => <motion.div key={index} initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.2,
        duration: 0.5
      }} className="bg-[#0a1628]/60 backdrop-blur-sm p-6 rounded-xl border border-[#d4a843]/20 flex flex-col items-center text-center hover:border-[#d4a843] transition-colors cursor-default" data-id="element-22">
            <bonus.icon className="w-10 h-10 text-[#d4a843] mb-4" data-id="element-23" />
            <p className="text-white font-medium text-lg" data-id="element-24">{bonus.text}</p>
          </motion.div>)}
      </div>
    </div>;
}